import { Box, GridItem, SimpleGrid, Text } from "@chakra-ui/layout"
import { ElementType, FC } from "react"

type Props = {
  styles: any;
  title: string;
  count?: number;
  icon: ElementType;
}

export const DragPreviewBox: FC<Props> = ({ styles, icon, title, count }) => {
  const Icon = icon;

  return (
    <Box
      position="relative"
      layerStyle={['with-border', 'with-border-radius-small']}
      style={styles}
      bgColor="white"
      boxShadow="0px 1px 6px rgba(0, 0, 0, 0.16)"
      padding="7px 40px 7px 9px"
    >
      <SimpleGrid gridAutoFlow="column" gap="10px">
        <GridItem>
          <Icon boxSize="20px" color="brand.500" marginTop="-3px" />
        </GridItem>
        <GridItem>
          <Text colorScheme="text">{ title }</Text>
        </GridItem>
      </SimpleGrid>
      {count && (
        <Box
          position="absolute"
          top="-9px"
          right="-9px"
          color="white"
          fontWeight="600"
          borderRadius="50%"
          bgColor="brand.500"
          height="20px"
          width="20px"
          lineHeight="20px"
          textAlign="center"
          fontSize="sm"
        >
          { count }
        </Box>
      )}
    </Box>
  )
};
